import { commonCbEnv } from "./env.cb.common";

const env: Partial<typeof commonCbEnv> = {
  production: true,
  page: 'bursa-nivel-1',
  productCode: 'BURSA_1',
  meta: {
    siteTitle: 'Caruta cu bani - curs de investitii eficiente pe bursa nivelul 1',
    ogSiteName: 'Caruta Cu Bani',
    siteDescription: '',
    ogImageAlt: '',
    ogUrl: 'https://carutacubani.ro/cursuri/curs-investitii-eficiente-pe-bursa/',
    ogImage: 'https://carutacubani.ro/cursuri/curs-investitii-eficiente-pe-bursa/assets/images/bursa-nivel-1/cover-fb.png'
  }
};

export const environment = { ...commonCbEnv, ...env };
